import React from 'react';
import { AppShell, Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const MyApp = ({ children }) => {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  return (
    <AppShell
      styles={(theme) => ({
        root: {
          minHeight: '100vh',
        },
        main: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'white',
          color: theme.colorScheme === 'dark' ? theme.colors.gray[1] : theme.colors.gray[8],
          padding: 0,
          overflowX: 'hidden',
          minHeight: 'calc(100vh - 292px)',
        },
      })}
    >
      {/* <AspectRatio ratio={1080} sx={{ height: 'calc(100vh - 2px)' }}> */}
      {/* <BackgroundImage src="../../assets/back.svg"> */}
      <Box p="xl">{children}</Box>
      {/* </BackgroundImage> */}
      {/* </AspectRatio> */}
      {/* <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
        <Button
          onClick={() => navigate(-1)}
          color="blue"
          radius="xl"
          size="xl"
          leftIcon={<Image src={backButton} width={45} height={30} />}
        >
          Go Back
        </Button>
        <Button onClick={() => navigate('/')} color="blue" radius="xl" size="xl">
          Home
        </Button>
      </Group> */}
    </AppShell>
  );
};

export default MyApp;
